import { ICursor, IPaginateElements, IPagination } from '@/store/types/search.types';
import {
  IRestrictionsGroup,
  IRestrictionsGroupMetadata,
  IStateRestrictionsGroup,
  TRestrictionsGroupMetadataValue,
  TRestrictionsGroupType,
} from '@/store/models/restriction.model';
import { TAppError, IBaseAction, IBaseState } from '@/store/types/base.state';

export enum PredefRestrictionsGroupActionTypes {
  SEARCH_PREDEF_RESTRICTIONS_GROUPS = 'PREDEF_GROUP.SEARCH_PREDEF_RESTRICTIONS_GROUPS',
  SEARCH_PREDEF_RESTRICTIONS_GROUPS_SUCCESS = 'PREDEF_GROUP.SEARCH_PREDEF_RESTRICTIONS_GROUPS_SUCCESS',
  SEARCH_PREDEF_RESTRICTIONS_GROUPS_FAIL = 'PREDEF_GROUP.SEARCH_PREDEF_RESTRICTIONS_GROUPS_FAIL',

  ADD_PREDEF_RESTRICTION_GROUP = 'PREDEF_GROUP.SAVE_PREDEF_RESTRICTION_GROUP',
  ADD_PREDEF_RESTRICTION_GROUP_SUCCESS = 'PREDEF_GROUP.SAVE_PREDEF_RESTRICTION_GROUP_SUCCESS',
  ADD_PREDEF_RESTRICTION_GROUP_FAIL = 'PREDEF_GROUP.SAVE_PREDEF_RESTRICTION_GROUP_FAIL',

  UPDATE_PREDEF_RESTRICTION_GROUP = 'PREDEF_GROUP.UPDATE_PREDEF_RESTRICTION_GROUP',
  UPDATE_PREDEF_RESTRICTION_GROUP_SUCCESS = 'PREDEF_GROUP.UPDATE_PREDEF_RESTRICTION_GROUP_SUCCESS',
  UPDATE_PREDEF_RESTRICTION_GROUP_FAIL = 'PREDEF_GROUP.UPDATE_PREDEF_RESTRICTION_GROUP_FAIL',

  DELETE_PREDEF_RESTRICTION_GROUP = 'PREDEF_GROUP.DELETE_PREDEF_RESTRICTION_GROUP',
  DELETE_PREDEF_RESTRICTION_GROUP_SUCCESS = 'PREDEF_GROUP.DELETE_PREDEF_RESTRICTION_GROUP_SUCCESS',
  DELETE_PREDEF_RESTRICTION_GROUP_FAIL = 'PREDEF_GROUP.DELETE_PREDEF_RESTRICTION_GROUP_FAIL',

  GET_PREDEF_RESTRICTIONS_GROUP_METADATA = 'PREDEF_GROUP.GET_PREDEF_RESTRICTIONS_GROUP_METADATA',
  GET_PREDEF_RESTRICTIONS_GROUP_METADATA_SUCCESS = 'PREDEF_GROUP.GET_PREDEF_RESTRICTIONS_GROUP_METADATA_SUCCESS',
  GET_PREDEF_RESTRICTIONS_GROUP_METADATA_FAIL = 'PREDEF_GROUP.GET_PREDEF_RESTRICTIONS_GROUP_METADATA_FAIL',

  UPDATE_PREDEF_RESTRICTIONS_GROUP_SINGLE_METADATA = 'PREDEF_GROUP.UPDATE_PREDEF_RESTRICTIONS_GROUP_SINGLE_METADATA',
  UPDATE_PREDEF_RESTRICTIONS_GROUP_SINGLE_METADATA_SUCCESS = 'PREDEF_GROUP.UPDATE_PREDEF_RESTRICTIONS_GROUP_SINGLE_METADATA_SUCCESS',
  UPDATE_PREDEF_RESTRICTIONS_GROUP_SINGLE_METADATA_FAIL = 'PREDEF_GROUP.UPDATE_PREDEF_RESTRICTIONS_GROUP_SINGLE_METADATA_FAIL',

  UPDATE_PREDEF_RESTRICTIONS_GROUP_METADATA = 'PREDEF_GROUP.UPDATE_PREDEF_RESTRICTIONS_GROUP_METADATA',
  UPDATE_PREDEF_RESTRICTIONS_GROUP_METADATA_SUCCESS = 'PREDEF_GROUP.UPDATE_PREDEF_RESTRICTIONS_GROUP_METADATA_SUCCESS',
  UPDATE_PREDEF_RESTRICTIONS_GROUP_METADATA_FAIL = 'PREDEF_GROUP.UPDATE_PREDEF_RESTRICTIONS_GROUP_METADATA_FAIL',

  SAVE_RESTRICTIONS_PATH = 'PREDEF_GROUP.SAVE_RESTRICTIONS_PATH',

  RESET_RESTRICTIONS_GROUPS = 'PREDEF_GROUP.RESET_RESTRICTIONS_GROUPS',
}

export interface ISearchRestrictionsGroupsAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.SEARCH_PREDEF_RESTRICTIONS_GROUPS;
  restrictionsGroupType: TRestrictionsGroupType;
}

export interface ISearchRestrictionsGroupsSuccessAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.SEARCH_PREDEF_RESTRICTIONS_GROUPS_SUCCESS;
  restrictionsGroupType: TRestrictionsGroupType;
  restrictionsGroups: IRestrictionsGroup[];
  pagination: IPagination;
}

export interface ISearchRestrictionsGroupsFailAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.SEARCH_PREDEF_RESTRICTIONS_GROUPS_FAIL;
  restrictionsGroupType: TRestrictionsGroupType;
  error: TAppError;
}

export interface ISavePredefRestrictionGroupAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.ADD_PREDEF_RESTRICTION_GROUP;
}

export interface ISavePredefRestrictionGroupSuccessAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.ADD_PREDEF_RESTRICTION_GROUP_SUCCESS;
  restrictionsGroup: IRestrictionsGroup;
}

export interface ISavePredefRestrictionGroupFailAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.ADD_PREDEF_RESTRICTION_GROUP_FAIL;
  error: TAppError;
}

export interface IUpdatePredefRestrictionGroupAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.UPDATE_PREDEF_RESTRICTION_GROUP;
  restrictionsGroupType: TRestrictionsGroupType;
  restrictionsGroupId: number;
}

export interface IUpdatePredefRestrictionGroupSuccessAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.UPDATE_PREDEF_RESTRICTION_GROUP_SUCCESS;
  restrictionsGroup: IRestrictionsGroup;
}

export interface IUpdatePredefRestrictionGroupFailAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.UPDATE_PREDEF_RESTRICTION_GROUP_FAIL;
  restrictionsGroupType: TRestrictionsGroupType;
  restrictionsGroupId: number;
  error: TAppError;
}

export interface IDeletePredefRestrictionGroupAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.DELETE_PREDEF_RESTRICTION_GROUP;
}

export interface IDeletePredefRestrictionGroupSuccessAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.DELETE_PREDEF_RESTRICTION_GROUP_SUCCESS;
  restrictionsGroupType: TRestrictionsGroupType;
  restrictionsGroupId: number;
}

export interface IDeletePredefRestrictionGroupFailAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.DELETE_PREDEF_RESTRICTION_GROUP_FAIL;
  error: TAppError;
}

export interface IGetPredefRestrictionsGroupMetadataAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.GET_PREDEF_RESTRICTIONS_GROUP_METADATA;
  restrictionsGroupType: TRestrictionsGroupType;
  restrictionsGroupId: number;
}

export interface IGetPredefRestrictionsGroupMetadataSuccessAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.GET_PREDEF_RESTRICTIONS_GROUP_METADATA_SUCCESS;
  restrictionsGroupType: TRestrictionsGroupType;
  restrictionsGroupId: number;
  metadata: IRestrictionsGroupMetadata;
  cursor: ICursor;
}

export interface IGetPredefRestrictionsGroupMetadataFailAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.GET_PREDEF_RESTRICTIONS_GROUP_METADATA_FAIL;
  restrictionsGroupType: TRestrictionsGroupType;
  restrictionsGroupId: number;
  error: TAppError;
}

export interface IUpdatePredefRestrictionsGroupSingleMetadataAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.UPDATE_PREDEF_RESTRICTIONS_GROUP_SINGLE_METADATA;
  restrictionsGroupType: TRestrictionsGroupType;
  restrictionsGroupId: number;
}

export interface IUpdatePredefRestrictionsGroupSingleMetadataSuccessAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.UPDATE_PREDEF_RESTRICTIONS_GROUP_SINGLE_METADATA_SUCCESS;
  restrictionsGroupType: TRestrictionsGroupType;
  restrictionsGroupId: number;
  restriction: number | string;
  metadataValue: TRestrictionsGroupMetadataValue;
}

export interface IUpdatePredefRestrictionsGroupSingleMetadataFailAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.UPDATE_PREDEF_RESTRICTIONS_GROUP_SINGLE_METADATA_FAIL;
  restrictionsGroupType: TRestrictionsGroupType;
  restrictionsGroupId: number;
  error: TAppError;
}

export interface IUpdatePredefRestrictionsGroupMetadataAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.UPDATE_PREDEF_RESTRICTIONS_GROUP_METADATA;
  restrictionsGroupType: TRestrictionsGroupType;
  restrictionsGroupId: number;
}

export interface IUpdatePredefRestrictionsGroupMetadataSuccessAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.UPDATE_PREDEF_RESTRICTIONS_GROUP_METADATA_SUCCESS;
  restrictionsGroupType: TRestrictionsGroupType;
  restrictionsGroupId: number;
  metadatas: IRestrictionsGroupMetadata[];
}

export interface IUpdatePredefRestrictionsGroupMetadataFailAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.UPDATE_PREDEF_RESTRICTIONS_GROUP_METADATA_FAIL;
  restrictionsGroupType: TRestrictionsGroupType;
  restrictionsGroupId: number;
  error: TAppError;
}

export interface ISaveRestrictionPathAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.SAVE_RESTRICTIONS_PATH;
  tabId: number;
}

export interface IResetRestrictionGroupsAction extends IBaseAction {
  type: typeof PredefRestrictionsGroupActionTypes.RESET_RESTRICTIONS_GROUPS;
  restrictionGroupType: TRestrictionsGroupType;
}

export type TPredefRestrictionsGroupAction =
  | ISearchRestrictionsGroupsAction
  | ISearchRestrictionsGroupsSuccessAction
  | ISearchRestrictionsGroupsFailAction
  | ISavePredefRestrictionGroupAction
  | ISavePredefRestrictionGroupSuccessAction
  | ISavePredefRestrictionGroupFailAction
  | IUpdatePredefRestrictionGroupAction
  | IUpdatePredefRestrictionGroupSuccessAction
  | IUpdatePredefRestrictionGroupFailAction
  | IDeletePredefRestrictionGroupAction
  | IDeletePredefRestrictionGroupSuccessAction
  | IDeletePredefRestrictionGroupFailAction
  | IGetPredefRestrictionsGroupMetadataAction
  | IGetPredefRestrictionsGroupMetadataSuccessAction
  | IGetPredefRestrictionsGroupMetadataFailAction
  | IUpdatePredefRestrictionsGroupSingleMetadataAction
  | IUpdatePredefRestrictionsGroupSingleMetadataSuccessAction
  | IUpdatePredefRestrictionsGroupSingleMetadataFailAction
  | IUpdatePredefRestrictionsGroupMetadataAction
  | IUpdatePredefRestrictionsGroupMetadataSuccessAction
  | IUpdatePredefRestrictionsGroupMetadataFailAction
  | ISaveRestrictionPathAction
  | IResetRestrictionGroupsAction;

export interface IPaginateStateRestrictionsGroup extends IPaginateElements<IStateRestrictionsGroup>, IBaseState {}

export interface IRestrictionsGroupState extends IBaseState {
  restrictionsGroups: Record<TRestrictionsGroupType, IPaginateStateRestrictionsGroup>;
  tabIdRestriction: number;
}
